import { format, formatDistanceToNow, parseISO, isValid } from 'date-fns';
import { fr } from 'date-fns/locale';

const toValidDate = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;

    let parsed = parseISO(trimmed);
    if (isValid(parsed)) return parsed;

    parsed = new Date(trimmed);
    return isValid(parsed) ? parsed : null;
  }

  const parsed = new Date(value);
  return isValid(parsed) ? parsed : null;
};

export const fmtDate = (d) => {
  const date = toValidDate(d);
  return date ? format(date, 'dd/MM/yyyy', { locale: fr }) : '—';
};

export const fmtDatetime = (d) => {
  const date = toValidDate(d);
  return date ? format(date, 'dd/MM/yyyy HH:mm', { locale: fr }) : '—';
};

export const fmtRelative = (d) => {
  const date = toValidDate(d);
  return date ? formatDistanceToNow(date, { locale: fr, addSuffix: true }) : '—';
};

/**
 * Rend un numéro de téléphone cliquable (tel: link).
 * Sur mobile → ouvre le composeur. Sur desktop → app par défaut.
 */
export const PhoneLink = ({ phone, style, children }) => {
  if (!phone) return null;
  const clean = phone.replace(/\s+/g, '');
  return (
    <a
      href={`tel:${clean}`}
      onClick={e => e.stopPropagation()}
      style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer', ...style }}
    >
      {children || phone}
    </a>
  );
};

export const initials = (name) => {
  if (!name) return '??';
  return name
    .split(' ')
    .filter(Boolean)
    .map((w) => w[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const scoreClass = (score) => {
  if (score >= 75) return 'high';
  if (score >= 50) return 'medium';
  return 'low';
};

export const statusConfig = {
  nouveau:                   { label: 'Nouveau',              color: 'badge-blue',   kanbanColor: '#2563eb' },
  en_cours_de_traitement:    { label: 'En traitement',        color: 'badge-orange', kanbanColor: '#f05a1a' },
  envoye_equipe_ta:          { label: 'Envoyé TA',            color: 'badge-cyan',   kanbanColor: '#0891b2' },
  en_cours_de_sourcing:      { label: 'En sourcing',          color: 'badge-yellow', kanbanColor: '#d97706' },
  short_list_envoyee:        { label: 'Shortlist envoyée',    color: 'badge-blue',   kanbanColor: '#6366f1' },
  top_profil_envoye:         { label: 'Top profil envoyé',    color: 'badge-green',  kanbanColor: '#059669' },
  repondu:                   { label: 'Répondu',              color: 'badge-green',  kanbanColor: '#16a34a' },
  gagne:                     { label: 'Gagné',                color: 'badge-green',  kanbanColor: '#15803d' },
  perdu:                     { label: 'Perdu',                color: 'badge-red',    kanbanColor: '#dc2626' },
  supprime:                  { label: 'Supprimé',             color: 'badge-gray',   kanbanColor: '#6b7280' },
  termine:                   { label: 'Terminé',              color: 'badge-gray',   kanbanColor: '#374151' },
};

export const getRoleName = (role) => {
  const map = {
    admin: 'Administrateur',
    ingenieur_affaires: "Ingénieur d'Affaires",
    talent_acquisition: 'Talent Acquisition',
  };
  return map[role] || role;
};